import { useState, useEffect, useRef } from 'react';

export default function useBackgroundAudio() {
  const [audioPlaying, setAudioPlaying] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    audioRef.current = new Audio(
      'https://assets.mixkit.co/music/preview/mixkit-meditation-flute-128.mp3'
    );
    audioRef.current.loop = true;
    audioRef.current.volume = 0.4;

    const startOnInteraction = () => {
      if (audioRef.current && !audioRef.current.paused) return;
      audioRef.current
        .play()
        .then(() => setAudioPlaying(true))
        .catch(() => {});
      window.removeEventListener('click', startOnInteraction);
      window.removeEventListener('keydown', startOnInteraction);
    };

    window.addEventListener('click', startOnInteraction);
    window.addEventListener('keydown', startOnInteraction);

    return () => {
      if (audioRef.current) audioRef.current.pause();
      window.removeEventListener('click', startOnInteraction);
      window.removeEventListener('keydown', startOnInteraction);
    };
  }, []);

  const toggleAudio = () => {
    if (!audioRef.current) return;
    if (audioPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play().catch((err) => console.log('Audio autoplay blocked:', err));
    }
    setAudioPlaying(!audioPlaying);
  };

  return { audioPlaying, toggleAudio };
}